// General Types
export const PRODUCT_SORT_PRICE_LOW = 'sortLowPrice';
export const PRODUCT_SORT_PRICE_HIGH = 'sortHighPrice';
export const PRODUCT_SORT_NEW = 'sortNew';
export const PRODUCT_SORT_OLD = 'sortOld';
export const PRODUCT_SORT_POPULAR = 'sortPopular';
export const PRODUCT_SORT_BEST_SELLING = 'sortBestSelling';








